import { IonItem, IonLabel, IonLoading, IonToggle } from "@ionic/react";
import React, { useCallback } from "react";
import { useOfflineStore } from "../store/offline-mode";
import { useHistory } from "react-router";
import { useWorkOrderStore } from "../store/wo-order";
import useSyncOfflineUpdates from "../hooks/offline/useSyncOfflineUpdates";
import { useUserStore } from "../store/user";
import { useSettingsStore } from "../store/settings";
import { useEquipmentStore } from "../store/equipment";
import { useCycleCountStore } from "../store/cycle-count";

const OfflineToggle: React.FC = () => {
  const isOffline = useOfflineStore((state) => state.isOffline);
  const toggleOffline = useOfflineStore((state) => state.toggleOffline);
  const resetWoStore = useWorkOrderStore((state) => state.reset);
  const resetEquipmentStore = useEquipmentStore((state) => state.reset);
  const resetUserStore = useUserStore((state) => state.reset);
  const resetSettingStore = useSettingsStore((state) => state.reset);
  // reset only the cycle-count DATA store (downloaded batches/items/meta); the
  // write-back queue (cycle-count-offline-updates) is intentionally left intact
  // so failed submissions can still be retried — mirrors the WO reset behavior
  const resetCycleCountStore = useCycleCountStore((state) => state.reset);
  const history = useHistory();
  const { syncOfflineUpdates, isSyncing } = useSyncOfflineUpdates();

  const handleOfflineToggle = useCallback(async () => {
    toggleOffline();
    //when offline is toggled on
    if (!isOffline) history.push("/WorkOrders/true");
    //when offline is toggled off
    if (isOffline) {
      try {
        await syncOfflineUpdates(); //start syncing
      } finally {
        //reset storage and route to the upload-data page even if sync errored
        resetWoStore();
        resetEquipmentStore();
        resetUserStore();
        resetSettingStore();
        resetCycleCountStore();
        history.replace("/offline/upload-data");
      }
    }
  }, [
    history,
    isOffline,
    resetCycleCountStore,
    resetEquipmentStore,
    resetSettingStore,
    resetUserStore,
    resetWoStore,
    syncOfflineUpdates,
    toggleOffline,
  ]);

  return (
    <IonItem>
      <IonLoading
        isOpen={isSyncing}
        message="Syncing your offline changes. This may take a while for large counts — please keep the app open."
      />
      <div style={{ width: "100%", paddingTop: 5 }}>
        <IonLabel>
          <h3 style={{ fontSize: "12px" }}>
            App is currently in offline mode. This means work orders will be
            loaded from cache.
          </h3>
        </IonLabel>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            width: "100%",
          }}
        >
          <IonLabel>Is offline</IonLabel>
          <IonToggle checked={isOffline} onClick={handleOfflineToggle}>
            Checked Toggle
          </IonToggle>
        </div>
      </div>
    </IonItem>
  );
};

export default OfflineToggle;
